import { UpdateTournamentAssetsFields } from 'modules/tournaments/interfaces/forms';
import { useCallback } from 'react';
import { UseFormSetValue } from 'react-hook-form/dist/types/form';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useTournamentUploadsHandler = (setValue: UseFormSetValue<any>) => {
  const onSuccessUploadHandler = useCallback(
    (payload: Partial<UpdateTournamentAssetsFields>) => {
      const value: string = Object.values(payload)[0] ?? '';
      const key = Object.keys(payload)[0] as 'cardImageKey' | 'bannerImageKey';

      if (key) {
        setValue(key, value);
      }
    },
    [setValue]
  );

  return { onSuccessUploadHandler };
};
